import { put, takeEvery } from "redux-saga/effects";
import { createBrowserHistory } from "history";
import {
  FETCH_SUPPORTTYPE_INIT_ACTION,
  FETCH_SUPPORTTYPE_SUCCESS_ACTION,
  FETCH_SUPPORTTYPE_FAIL_ACTION,
  FETCH_SUPPORTDETAILS_INIT_ACTION,
  FETCH_SUPPORTDETAILS_SUCCESS_ACTION,
  FETCH_SUPPORTDETAILS_FAIL_ACTION,
  FETCH_SUPPORTHISTORY_INIT_ACTION,
  FETCH_SUPPORTHISTORY_SUCCESS_ACTION,
  FETCH_SUPPORTHISTORY_FAIL_ACTION,
  FETCH_SUPPORTUSERS_INIT_ACTION,
  FETCH_SUPPORTUSERS_SUCCESS_ACTION,
  FETCH_SUPPORTUSERS_FAIL_ACTION,
  EDIT_SUPPORT_INIT_ACTION,
  EDIT_SUPPORT_SUCCESS_ACTION,
  EDIT_SUPPORT_FAIL_ACTION,
  ADD_SUPPORTHISTORY_INIT_ACTION,
  ADD_SUPPORTHISTORY_SUCCESS_ACTION,
  ADD_SUPPORTHISTORY_FAIL_ACTION,
} from "./action";

import { push } from "connected-react-router";
import { appConfig } from "../../config";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

var btoa = require("Base64").btoa;
var history = createBrowserHistory();

function* fetchSupportType() {
  try {

    const token = localStorage.getItem("token");
    const res = yield fetch(`${appConfig.ip}/supportType?limit=100`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });

    if (!res.ok) {
      let errJSON = {};
      try {
        errJSON = yield res.json();
      } catch {
        throw Object.assign(res, errJSON);
      }
    } else {
      const resJSON = yield res.json();

      yield put({
        type: FETCH_SUPPORTTYPE_SUCCESS_ACTION,
        payload: resJSON,
      });
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({
        type: FETCH_SUPPORTTYPE_FAIL_ACTION,
        error: err,
      });
    }
  }
}

function* fetchSupport(value) {
  console.log(value);
  const token = localStorage.getItem("token");

  let pageno = (!(value.value)) ? 1 : (value.value.page === undefined ? 1 : value.value.page);
  let search = (!(value.value)) ? "" : (value.value.search === "" ? "" : value.value.search);
  let filter = (!(value.value)) ? "" : (value.value.filter === "" ? "" : value.value.filter);

  try {
    const res = yield fetch(
      `${appConfig.ip}/support?search=${search}&sprtType=${filter}&limit=10&page=${pageno}`,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`
        }
      }
    );
    if (!res.ok) {
      throw res;
    } else {
      const resJSON = yield res.json();
      yield put({
        type: FETCH_SUPPORTDETAILS_SUCCESS_ACTION,
        payload: resJSON
      });
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({ type: FETCH_SUPPORTDETAILS_FAIL_ACTION, error: err });
    } else {
    }
  }
}

function* fetchSupportHistory(value) {
  const token = localStorage.getItem("token");
  const pageno = ((!value.value.page) ? 1:(value.value.page === undefined ? 1 : value.value.page));

  try {
    const res = yield fetch(
      `${appConfig.ip}/supportHistory?limit=5&page=${pageno}&&sprtId=${value.value.sprtId}`,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`
        }
      }
    );
    if (!res.ok) {
      throw res;
    } else {
      const resJSON = yield res.json();

      yield put({
        type: FETCH_SUPPORTHISTORY_SUCCESS_ACTION,
        payload: resJSON
      });
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({
        type: FETCH_SUPPORTHISTORY_FAIL_ACTION,
        error: err
      });
    } else {
    }
  }
}

function* fetchSupportUsers() {
  try {

    const token = localStorage.getItem("token");
    const res = yield fetch(`${appConfig.ip}/supportUsers?limit=100`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });

    if (!res.ok) {
      let errJSON = {};
      try {
        errJSON = yield res.json();
      } catch {
        throw Object.assign(res, errJSON);
      }
    } else {
      const resJSON = yield res.json();

      yield put({
        type: FETCH_SUPPORTUSERS_SUCCESS_ACTION,
        payload: resJSON,
      });
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({
        type: FETCH_SUPPORTUSERS_FAIL_ACTION,
        error: err,
      });
    }
  }
}

function* editSupport(value) {
 
  try {

    const id = value.value.sprtId;
    const token = localStorage.getItem("token");

      const supportValue = {
        status: value.value.status,
      };
      const res = yield fetch(`${appConfig.ip}/support/` + id, {
        method: "PUT",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(supportValue)

      });
      if (!res.ok) {
        let errJSON = {};
        try {
          errJSON = yield res.json();
        } catch { }
        throw Object.assign(res, errJSON);
      } else {
        const resJSON = yield res.json();

        yield put({
          type: EDIT_SUPPORT_INIT_ACTION,

        });
        yield put({
          type: EDIT_SUPPORT_SUCCESS_ACTION,
          payload: resJSON,
        });

      }

  } catch (err) {

    if (err.ok === false) {
      yield put({ type: EDIT_SUPPORT_FAIL_ACTION, error: err });
    } else {
    }
  }

}

function* addSupportHistory(value) {
  try {
    const token = localStorage.getItem("token");

    const Value = {
      sprtId: value.value.sprtId,
      asgndTo: value.value.asgndTo,
      priority: value.value.priority,
      remarks: value.value.remarks
    };
      const res = yield fetch(`${appConfig.ip}/supportHistory/`, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(Value),
      });
  
      if (!res.ok) {
        throw res;
      } else {
        const resJSON = yield res.json();
  
        yield put({
          type: FETCH_SUPPORTDETAILS_INIT_ACTION,
        });
        
        yield toast.success("Support History added successfully", {
          autoClose: 3000,
        });
       
        yield put({
          type: ADD_SUPPORTHISTORY_SUCCESS_ACTION,
          payload: resJSON,
        });
      }
    } catch (err) {
      if (err.ok === false) {
        yield put({
          type: ADD_SUPPORTHISTORY_FAIL_ACTION,
          error: err,
        });
      }
    }
  }

export function* SupportActionWatcher() {
  yield takeEvery(FETCH_SUPPORTTYPE_INIT_ACTION, fetchSupportType);
  yield takeEvery(FETCH_SUPPORTDETAILS_INIT_ACTION, fetchSupport);
  yield takeEvery(EDIT_SUPPORT_INIT_ACTION, editSupport);
  yield takeEvery(ADD_SUPPORTHISTORY_INIT_ACTION, addSupportHistory);
  yield takeEvery(FETCH_SUPPORTHISTORY_INIT_ACTION, fetchSupportHistory);
  yield takeEvery(FETCH_SUPPORTUSERS_INIT_ACTION, fetchSupportUsers);
}
